export const lazyLoadDirective = {
  mounted(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 加载真实图片
          el.src = binding.value
          // 图片加载完成后淡入效果
          el.onload = () => {
            el.style.opacity = 1
          }
          // 停止观察
          observer.unobserve(el)
        }
      })
    }, {
      rootMargin: '200px', // 提前200px加载
      threshold: 0.01 // 1%可见即触发
    })
    
    observer.observe(el)
  }
}